export default "__VITE_ASSET__Bu_yKIGo__"